import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { CommonMutationCrumbs } from './breadcrumb';

export const ResearchNotificationsMutationCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca Registrazioni SC - Anagrafe',
    path: '/mutazioni/notifiche-da-stato-civile/',
  },
];

export const DetailNotificationsMutationCrumbs = [
  ...ResearchNotificationsMutationCrumbs,
  {
    name: 'Dettaglio Registrazioni SC - Anagrafe',
    path: '/mutazioni/notifiche-da-stato-civile/visualizza/:id/:idNotifica',
  },
];

export const EditNotificationsMutationCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...ResearchNotificationsMutationCrumbs,
    {
      name: 'Modifica Registrazioni SC - Anagrafe',
      path: goBackUrl,
    },
  ];
};

export const BirthNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationNotificationsResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationNotificationsNonResidentMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyNotificationsMutationCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailNotificationsMutationCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: '/mutazioni/notifiche-da-stato-civile/modifica/:id/:idNotifica/convivenza/nascita',
    },
  ];
};
